// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__9YCX5","page__animation--in":"layout_page__animation--in__rb5FH"};